import Image from "next/image";
import style from "./RightImage.module.scss";

function RightImage({ dictionary, blockData = {} }) {
	return (
		<section className={style.container}>
			<div className={style.content}>
				<div className={style.text}>
					<h2 className={style.title}>{dictionary[blockData.title] || <div dangerouslySetInnerHTML={{ __html: blockData.title }} />}</h2>
					<p className={style.description}>{dictionary[blockData.description] || blockData.description}</p>
				</div>
				<Image className={style.image} src={blockData.imageSrc} width={666} height={500} alt="Image in anime style" />
			</div>
		</section>
	);
}

export default RightImage;
